import React from 'react';
import { makeStyles } from '@material-ui/core';
import Page from 'src/components/elements/Page';

const useStyles = makeStyles(() => ({
  root: {}
}));

const HomeView = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Home">
      <h1>Inicio</h1>
    </Page>
  );
};

export default HomeView;
